<template>
    <el-card>
        <!--<Header slot="header"></Header>-->
        <Content :getCartProducts="getCartProducts"></Content>
        <Footer
            :cartProducts="cartProducts"
            :getCartProducts="getCartProducts"
        ></Footer>
    </el-card>
</template>
<script>
    import Vue from 'vue';
    import AddProduct from '../components/AddPro';
    import {getCartProducts} from '../stores/api';

    Vue.component('Header', AddProduct.Header);
    Vue.component('Content', AddProduct.Content);
    Vue.component('Footer', AddProduct.Footer);

    export default {
        data () {
            return {
                cartProducts: [],
            };
        },
        beforeMount() {
            this.getCartProducts();
        },
        methods: {
            async getCartProducts() {
                getCartProducts().then(res => {
                    this.cartProducts = res.data.goods_list;
                });
            }
        },
    };
</script>

<style lang="less" scoped>
    /deep/ .el-card__header {
        padding: 10px 40px;
    }
    /deep/ .el-card__body {
        padding: 30px 40px;

    }
</style>



// WEBPACK FOOTER //
// src/router/AddProduct.vue